import React, {useEffect, useRef, useState} from "react";
import {Loader} from "../../../../../shared/features/Loader";
import {generateMediaUrl} from "../../../../../utils/generateMediaUrl";
import {formatDate, hasPermission} from "../../../../../utils/helperFunctions";
import i18n from "i18next";
import dayjs from "dayjs";
import UserIcons from "../../../../../shared/features/userIcons/UserIcons";
import './VideoBlock.scss';
import {Link} from "react-router-dom";
import {ChainIcon, EditNewIcon, ShevronTopIcon} from "../../../../../image";
import DropdownMenu from "../../../../../shared/features/dropdownMenu";
import ChainsDropDown from "../../../../../shared/features/Chains/ChainsDropDown/ChainsDropDown";
import {getDistanceRightBody} from "../../../../../shared/features/Chains/helpers";
import {useTranslation} from "react-i18next";
import {Dropdown, Popover, Tooltip} from "antd";
import {MarkDownText} from "../../../../../shared/features/MarkDownText";
import Highlighter from "react-highlight-words";
import AvatarGroup from "../../../../ManageData/ManageVideo/AvatarGroup/AvatarGroup";
import UserInfoModal from "../../Users/modals/userInfoModal/UserInfoModal";
import {history} from "../../../../../utils/history";
import {ROUTERS_MAP} from "../../../../../utils/routes";
import {useSelector} from "react-redux";
import {ROLE_ITEMS} from "../../../../../utils/constants";
import {Text} from "../../../../../modules";

const VideoBlock = ({tooltipTitle, updateUserModal, isDetach, video, badge, routs, channelsList, chainList, ref, isChaneType = false, isPreview, color, isSearchText}) => {

	const [isVisibleDefaultPoster, setIsVisibleDefaultPoster] = useState(false);
	const [isLoader, setLoader] = useState(false);
	const [showChannels, setShowChannels] = useState(false);
	const blockRef = useRef();
	const badgeChainsId = (badge?.chains || []).map((item)=>item.id);
	const [showModal, setShowModal] = useState(false)
	const [currentUser, setCurrentUser] = useState(null)
	const userProfile = useSelector(state => state.profile.userProfile);
	const channels = useSelector(state => state?.channels?.channels || []);
	const allChannelsIds = channels.map((item) => item?.id);
	const videoChannels = (video?.channels || []).filter((item) => allChannelsIds.includes(item));
	const countChannels = videoChannels.length;

	const chainsVideo = (chainList || [])
		.filter((item) => (video?.chains_ids || []).includes(item?.id))
		.filter((item) =>  (badgeChainsId).includes(item?.id));

	const {t} = useTranslation();

	useEffect(() => {
		document.addEventListener('click', toggleMenu, {capture: true});
		return () => {
			document.removeEventListener('click', toggleMenu)
		}
	}, []);

	const toggleMenu = (event) => {
		const path = event.composedPath ? event.composedPath() : event.path
		if(!path?.includes(ref?.current)) {
			setShowChannels(false)
		}
	}
	const distanceRight = getDistanceRightBody(video?.id);
	const [openPopover, setOpenPopover] = useState(false);

	const handleOpenChange = (open) => {
		setOpenPopover(open);
	};

	function toggleUserModal(person) {
		if(userProfile?.attached_person?.id === person?.id || userProfile?.id === person?.user_id){
			history.push(ROUTERS_MAP.PROFILE);
		}else{
			setShowModal(!showModal)
			setCurrentUser(person)
		}
	}
	const refVideoWrap = useRef();

	return (
		<div
			className="video--poster"
			style={{
				'--distanceRight': `${distanceRight < 150 ? '10px' : 'auto'}`,
		}}
			id={video?.id}
		>
			{isLoader && (
				<div className="video--loader">
					<Loader size={50}/>
				</div>
			)}
			<div className="video__wrap" ref={refVideoWrap}>
			<Link to={{
				pathname: `/dashboard/videos/video/${video?.id}`,
				state: {routs}
			}} className={'video--poster'}
			>
				{isPreview ?
					<Tooltip
						overlayInnerStyle={{width: '480px', padding: 0, backgroundColor: 'rgba(24, 24, 24, 0.95)'}}
						title={
							<div className='video-preview-block'>
								<p className='video-preview-block--title'>{video?.description}</p>
								<MarkDownText
									className="video-preview-block--text"
									text={video?.summary}
								/>
							</div>
						}
						placement="bottom"
						mouseEnterDelay={0.5}
					>

						<img
							className="video--poster-img"
							src={video?.thumbnail_url || "https://grinvich.com/static/assets/images/media-default-video.png"}
							onError={({ currentTarget }) => {
								currentTarget.onerror = null; // prevents looping
								currentTarget.src="https://grinvich.com/static/assets/images/media-default-video.png";
							}}
							alt={video?.description}
						/>
					</Tooltip>
					:
					<img
						className="video--poster-img"
						src={video?.thumbnail_url || "https://grinvich.com/static/assets/images/media-default-video.png"}
						onError={({ currentTarget }) => {
							currentTarget.onerror = null; // prevents looping
							currentTarget.src="https://grinvich.com/static/assets/images/media-default-video.png";
						}}
						alt={video?.description}
					/>
				}
			</Link>
			<div className="video__channels" style={{width: refVideoWrap?.current?.offsetWidth - 20}}>
				{(chainList || []).length > 0 ?
					<div className="chain_list" style={{'--chain_сolor': channelsList?.[badge?.id]?.color || color || '#33BCC5'}}>
					<Popover
						arrow={false}
						trigger='click'
						placement="topLeft"
						onOpenChange={handleOpenChange}
						overlayClassName='test'
						content={
								<div className="chain_list" style={{'--chain_сolor': channelsList?.[badge?.id]?.color || color || '#33BCC5'}}>
									{chainsVideo.map((item) => (
										<Link
											key={item?.id}
											to={{
												pathname: `${ROUTERS_MAP.CHANNEL}/${badge?.id}/chains/${item?.id}`,
												state: {
													routs: [
														{
															path: ROUTERS_MAP.KNOWLEDGE_DATA,
															name: t('menu_item_knowledge')
														}
													]
												}
											}} className={'chain_item'}>
											<ChainIcon/>
											<p>{item.name}</p>
										</Link>
									))}
									{(hasPermission(ROLE_ITEMS.FOREIGN_VIDEO_CHAINS_FULL_ACCESS) || badge?.is_private) ?
									<Popover
										arrow={false}
										trigger='click'
										placement="rightTop"
										overlayClassName='popover_manage-chain'
										content={
											<ChainsDropDown
												isBindChain={true}
												chains={badge?.chains || []}
												channel={badge}
												videoInfo={video}
												routs={routs}
												isAll={isChaneType}
												channelStyle={channelsList?.[badge?.id]}
												isVideoChain={true}
											/>
										}
										>
										<div className="chain_item">
											<EditNewIcon/>
											Manage collection
										</div>
									</Popover>
										: null}
								</div>

					}
					>
								<div
						 			className="video__channels--badge"
									style={{width: refVideoWrap?.current?.offsetWidth - 52}}
								>
						 			<span className="dote" style={{backgroundColor: channelsList?.[badge?.id]?.color || '#33BCC5'}}/>
									<p>{badge?.name}</p>

										<div className="video__channels--badge--chevron">
											{(chainsVideo || [])?.length ?
												<>
													<span>{(chainsVideo || [])?.length}</span>
													<ChainIcon className="video__channels--badge--chevron-icon"/>
												</>
												: null}
											<ShevronTopIcon style={{transform: openPopover ? 'rotate(180deg)' : 'rotate(360deg)', width: 20, height: 16}}/>
										</div>

							</div>
					</Popover>
					</div>
					:
					<>
						{Object.keys(badge || {}).length ?
							<div
								className="video__channels--badge"
								onClick={() => setShowChannels(!showChannels)}
							>
								<span className="dote" style={{backgroundColor: badge?.bg}}/>
								{badge?.name}
							</div>
							: null}
					</>
				}
				{countChannels - 1 > 0 &&
					<div
						className="channels_count"
						onClick={() => setShowChannels(!showChannels)}
					>
						+{countChannels - 1}
					</div>
				}
			</div>
		</div>
			{
				video?.duration && <div className="video__time">
					{video?.duration}
				</div>
			}

			<div className="video__info">
				<div className="video__info--wrap">
					{isSearchText ?
						<>
							{tooltipTitle ?
								<Tooltip
									placement="left"
									title={video?.description}
								>
									<Highlighter
										highlightClassName="highlight-text"
										searchWords={[isSearchText]}
										autoEscape={true}
										textToHighlight={video?.description}
									/>
								</Tooltip>
								:
								<Highlighter
									highlightClassName="highlight-text"
									searchWords={[isSearchText]}
									autoEscape={true}
									textToHighlight={video?.description}
								/>
							}
						</>
						:
						<>
							{
								tooltipTitle ?
									<Tooltip
										placement="left"
										title={video?.description}
									>
										<Text size="f14" font="bold">{video?.description}</Text>
									</Tooltip>
									:
									<Text size="f14" font="bold">{video?.description}</Text>
							}
						</>
						}
						<div className="video__info-bottom">
							<div className="video__info-date">
								<span>{formatDate(video?.created_at, i18n.language)},</span>
								<span>{dayjs(video?.created_at).format('HH:mm:ss')}</span>
							</div>
							<AvatarGroup
								users={video?.persons || []}
								videoId={video?.id}
								isDetach={isDetach}
								toggleUserModal={toggleUserModal}
								updateUserModal={updateUserModal}
							/>
						</div>
				</div>


			</div>
			{
				showChannels && !!video?.channels.length &&
				<div className="channels_list">
					{
						video?.channels?.map(item => {
							return <div className="channel_item"
							            key={channelsList[item]?.name}
							            style={{
								            backgroundColor: channelsList[item]?.bgColor,
								            color: channelsList[item]?.color,
							            }}>
								{channelsList[item]?.name}
							</div>
						})
					}
				</div>
			}
			{showModal && <UserInfoModal show={showModal} closeModal={toggleUserModal} user={currentUser}
			/>}
		</div>
	)
}

export default VideoBlock